module.exports = __webpack_public_path__ + "static/most-implementable-winter-2022-547827a8efcdeb28d8383acd7034638f.svg";